import { render, staticRenderFns } from "./NewLoginComponent.vue?vue&type=template&id=7a5b8d6a&"
import script from "./NewLoginComponent.vue?vue&type=script&lang=js&"
export * from "./NewLoginComponent.vue?vue&type=script&lang=js&"
import style0 from "./NewLoginComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports